import { checkViewerPermission } from "services/utils/HelperFunction";

const approvalScreens = [
  "Leaves", "Comp Off", "Attendance Correction", "Schedule Change", "Permissions",
  "On Duty", "Break", "Overtime", "Off Day Duty", "Advance Salary", "Expense",
];

export const getHomeDashboardAccess = (moduleDetails) => {
  const modules = Array.isArray(moduleDetails) ? moduleDetails : [];
  const canView = (module, screen) => checkViewerPermission(modules, module, screen);
  const availableModules = new Set();
  const canViewAttendanceOverview = ["Employee View", "Department View", "Shift View"]
    .some((screen) => canView("Attendance", screen));
  const canViewEmployeeAttendance = canView("Attendance", "Employee View");
  if (canViewAttendanceOverview) availableModules.add("Attendance");
  for (const [module, screen] of [
    ["Rosters", "Roster"], ["Leave Balances", "Leave Balances"], ["EOD Report", "EOD Report"],
  ]) {
    if (canView(module, screen)) availableModules.add(module);
  }
  if (modules.find((module) => module?.module_name === "Reports")?.submodules
    ?.some((submodule) => submodule?.permissions?.viewer === true)) {
    availableModules.add("Reports");
  }
  const approvalAccess = {
    leave: canView("Approvals", "Leaves"),
    overtime: canView("Approvals", "Overtime"),
    permission: canView("Approvals", "Permissions"),
    // The endpoint's total is not broken down by every approval category.
    // Only show it when none of those categories are restricted.
    all: approvalScreens.every((screen) => canView("Approvals", screen)) &&
      modules.find((module) => module?.module_name === "Approvals")?.submodules
        ?.every((submodule) => submodule?.permissions?.viewer === true),
  };
  if (approvalScreens.some((screen) => canView("Approvals", screen))) {
    availableModules.add("Approvals");
  }
  return { availableModules, canViewAttendanceOverview, canViewEmployeeAttendance, approvalAccess };
};
